<div class="car_video">
  <div class="inner_cardesc_contents">
    <video width="320" height="180" controls="" controlslist="nodownload" playsinline>
      <source type="video/mp4" [src]="movieUrl">
      Your browser does not support the video tag. 
  </video>
  </div>
</div>
